(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-option"] && !Shopify.designMode) return;
  try {
    (function () {
		if (window.__cr8recSizeUnitToggleBound) return;
		window.__cr8recSizeUnitToggleBound = true;

		function convertSize(value, unit) {
			var numeric = parseFloat(value);
			if (Number.isNaN(numeric)) return value;
			if (unit === 'uk') return (numeric - 1).toString().replace('.0', '');
			if (unit === 'eu') return Math.round(numeric + 33).toString();
			return value;
		}

		function updateFieldset(fieldset, unit) {
			fieldset.querySelectorAll('[data-size-option-label]').forEach(function (label) {
				var usSize = label.getAttribute('data-us-size') || label.textContent.trim();
				label.textContent = convertSize(usSize, unit);
			});

			var checkedInput = fieldset.querySelector('input[type="radio"]:checked');
			var selected = fieldset.querySelector('[data-selected-size-value]');
			if (checkedInput && selected) {
				selected.textContent = convertSize(checkedInput.value, unit);
			}
		}

		document.addEventListener('click', function (event) {
			var button = event.target.closest('[data-size-unit-toggle] button');
			if (!button) return;
			var toggle = button.closest('[data-size-unit-toggle]');
			var fieldset = button.closest('fieldset');
			if (!toggle || !fieldset) return;
			toggle.querySelectorAll('button').forEach(function (item) {
				item.setAttribute('aria-pressed', item === button ? 'true' : 'false');
			});
			updateFieldset(fieldset, button.getAttribute('data-unit'));
		});

		document.addEventListener('change', function (event) {
			var input = event.target.closest('fieldset[data-handle="size"] input[type="radio"]');
			if (!input) return;
			var fieldset = input.closest('fieldset');
			var activeUnit = fieldset.querySelector('[data-size-unit-toggle] button[aria-pressed="true"]');
			updateFieldset(fieldset, activeUnit ? activeUnit.getAttribute('data-unit') : 'us');
		});
	})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-siblings"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__productVariationSiblingsBound) return;
    window.__productVariationSiblingsBound = true;

    document.addEventListener('click', function (event) {
      var anchor = event.target.closest('[data-product-variation-siblings] label a');
      if (!anchor) return;
      var container = anchor.closest('[data-product-variation-siblings]');
      if (!container) return;
      var sectionId = container.getAttribute('data-section-id');
      if (!sectionId) return;

      event.preventDefault();
      var url = anchor.getAttribute('href');
      if (!url) return;

      container.classList.add('is-loading');

      var fetchUrl = url + (url.indexOf('?') === -1 ? '?' : '&') + 'section_id=' + encodeURIComponent(sectionId);

      fetch(fetchUrl, { headers: { 'Accept': 'text/html' } })
        .then(function (res) { return res.text(); })
        .then(function (html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          var newSection = doc.getElementById('shopify-section-' + sectionId);
          var currentSection = document.getElementById('shopify-section-' + sectionId);
          if (newSection && currentSection) {
            currentSection.innerHTML = newSection.innerHTML;
          }
          if (window.history && window.history.pushState) {
            window.history.pushState({}, '', url);
          }
          document.dispatchEvent(new CustomEvent('product-variation:swapped', { detail: { url: url, sectionId: sectionId } }));
        })
        .catch(function () {
          window.location.href = url;
        });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
